import __var_0__ from '@stdlib/utils/define-nonenumerable-read-only-property';
import __var_1__ from './snanvariancetk.js';
import __var_2__ from './ndarray.js';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var setReadOnly = __var_0__;
var snanvariancetk = __var_1__;
var ndarray = __var_2__;


// MAIN //

setReadOnly( snanvariancetk, 'ndarray', ndarray );


// EXPORTS //
export default snanvariancetk;
